
// Dashboard services rest api calling

import { routes } from '../config/api_routes'

export const dashboardService = {
    // get dashboard 

    getDashboard : () => {    
        return window.axios.get(routes.getDashboardApi)
    },

    getUpdate : () => {
        return window.axios.get(routes.getUpdateApi)
    },

    getMonthWiseOrder : (formData) => {
        return window.axios.post(routes.getMonthWiseOrderApi,formData)
    },

    getMonthWiseSales : (formData) => {
        return window.axios.post(routes.getMonthWiseSalesApi,formData)
    },

    getMonthWiseEarning : (formData) => {
        return window.axios.post(routes.getMonthWiseEarning,formData)
    },

    getMonthWiseCancelOrder : (formData) => {
        return window.axios.post(routes.getMonthWiseCancelOrderApi,formData)
    },

    getMonthWiseDeliveredOrder : (formData) => {
        return window.axios.post(routes.getMonthWiseDeliveredOrderApi,formData)
    },

    getMonthWiseCustomer : (formData) => {
        return window.axios.post(routes.getMonthWiseCustomerApi,formData)
    },

    getOrderAverage : (formData) => {
        return window.axios.post(routes.getOrderAverageApi,formData)
    }
}